import React from "react"


function BestRadios({ data }) {

  const {area_name, area_name_full} = data

  return (
    <div className="container py-3" id="two-way-radios">
      <div className="row">
        <div className="col-12">
          <h2>The Best Two-Way Radios in {area_name}</h2>
          <p>Are you having trouble figuring out how to choose the best two-way radios for your needs? At CommUSA, we
            want to lend you a hand. Any time you rent or purchase one of our two-way radio systems, you get a
            communications professional to assist you every step of the way.</p>
          <h5>Here’s how it works.</h5>
          <p>Your CommUSA experience begins when you speak with one of our expert consultants. They’ll help you identify
            your specific needs and choose the right radio models for the size and type of territory you need to
            cover.</p>
          <p>Once you and your consultant customize a two-way radio strategy that ticks all of your boxes, we package
            and ship the order. Most two-way radio orders come with same-day fulfillment or can ship within a few short
            days.</p>
          <p>Since we offer the largest variety of Motorola two-way radios in {area_name_full}, we can always handle
            your
            needs, no matter how big of an order you throw at us. Plus, our two-way radio sales price-match guarantee
            means you’ll never have to worry about breaking the budget.</p>
          <p>It’s time to stop wondering where to find the best value on two-way radios and accessories— they’re all
            here at CommUSA.</p>
          <div className="btn-group" role="group">
            <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
              className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                        href="https://www.commusa.com/contact-us">Request
            Quote</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BestRadios
